/**
 * Marks a recorded instant apply as reverted (EXT-2020).
 *
 * Here rather than in the assistant frontend for the same reason the turn
 * markers are: the confirm-time apply is rolled back from `code-libraries`,
 * which cannot import the chat UI to say so.
 */
import {ActionCreator, createAction} from '@packages/utilities/create-action';

export const AI_ASSISTANT_INSTANT_APPLY_REVERTED =
  'AI_ASSISTANT_INSTANT_APPLY_REVERTED';

export type AiAssistantInstantApplyRevertedPayload = {
  /** The apply's undo turn id, as `InstantApplyRecord.turnId` carries it. */
  turnId: string;
};

export const aiAssistantInstantApplyReverted: ActionCreator<
  typeof AI_ASSISTANT_INSTANT_APPLY_REVERTED,
  AiAssistantInstantApplyRevertedPayload
> = createAction(AI_ASSISTANT_INSTANT_APPLY_REVERTED);
